var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    className: "w-3 h-3",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.781 5.333L5.205 1.757l.943-.942L11.333 6l-5.185 5.185-.943-.942 3.576-3.576H.667V5.333H8.78z"
  })));
}

export default SvgArrowRight;